import { TDeviceInfo } from '@grandstand-web/device-info/src/types'

export const getWindowDeviceInfo = (): TDeviceInfo => {
  return typeof window !== 'undefined' && window.deviceInfo ? window.deviceInfo : {}
}
